// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2OusU","rootSuccess":"CompleteLink_rootSuccess__1r_mF","rootFailure":"CompleteLink_rootFailure__1xxHJ","isDisabled":"CompleteLink_isDisabled__3r9xh"};